//LIBRARIES
import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { createNumberMask } from 'redux-form-input-masks';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

//HELPERS
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

const Divider = styled.hr`
  border-top: 1px solid #bbb;
  margin-top: 0;
`;

const Explainations = styled.div`
  text-align: left;
  margin: auto;
  width: 70%;
`;

const Link = styled.p`
  font-size: 18px;
  cursor: pointer;
  color: ${colors.RED};
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: bold;
`;

const currencyMask = createNumberMask({
  prefix: '$',
  decimalPlaces: 2,
  locale: 'en-US',
  allowEmpty: false,
});

const AutoPayAmountDetails = ({
  change,
  showPartialAmount,
  setShowPartialAmount,
  setShowHowItWorks,
  showHowItWorks,
  padDetails
}) => {
  
  const isExternal = featureEnabled('external_autopay') && hostIsCapreit();

  useEffect(() => {

    const { has_signed_pad_agreement, pay_total_amount, authorized_amount } = padDetails

    if(has_signed_pad_agreement) {
      //if partial_or_total_amount = false, you are paying in full
      //if partial_or_total_amount = true, you are partially paying
      change('partial_or_total_amount', !pay_total_amount);
      setShowPartialAmount(!pay_total_amount);
      change('partial_monthly_amount', authorized_amount);
    }
  }, [padDetails, setShowPartialAmount]); // eslint-disable-line

  return (
    <div>
      <div className="row" style={{ margin: '5px 0 15px 0' }}>
        <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
          <BooleanRadioButtons
            name="partial_or_total_amount"
            onUpdate={value => setShowPartialAmount(value)}
            style={{
              display: 'flex',
              textAlign: 'left',
              flexDirection: 'column-reverse',
            }}
            radioButtonStyle={{
              display: 'flex',
              margin: '15px 30px',
            }}
            trueLabel={
              !isExternal
                ? getTranslatedString('autopay.monthlyPaymentSpecificAmountTitle')
                : getTranslatedString('autopay.enterCustomAmount')
            }
            trueLabelDetail={
              !isExternal && getTranslatedString('autopay.monthlyPaymentSpecificAmountDetails')
            }
            falseLabel={
              !isExternal
                ? getTranslatedString('autopay.monthlyPaymentFullAmountTitle')
                : getTranslatedString('autopay.payTotalMonthlyAmount')
            }
            falseLabelDetail={
              !isExternal && getTranslatedString('autopay.monthlyPaymentFullAmountDetails')
            }
          />
        </div>
        {showPartialAmount && (
          <div>
            <div className="row" style={{ margin: '5px 20px 15px' }}>
              <div
                className={!isExternal ? '' : 'col-sm-12'}
                style={
                  isExternal
                    ? { marginTop: '15px' }
                    : { width: '80%', margin: 'auto', marginBottom: '10px' }
                }
              >
                <label
                  style={{
                    fontSize: '14px',
                  }}
                >
                  {getTranslatedString('autopay.enterMonthlyAmount')}
                </label>
                <Field // TODO Be able to change border color on focus for date picker and text fields
                  name="partial_monthly_amount"
                  component={TextField}
                  type="text"
                  variant="outlined"
                  {...currencyMask}
                />
              </div>
            </div>
            {featureEnabled('external_autopay') && (
              <div className="row" style={{ margin: '5px 20px 15px', fontSize: '16px' }}>
                <div className="col-sm-12" style={{ textAlign: 'left', marginTop: '15px' }}>
                  <h4>{getTranslatedString('autopay.allocatePayment')}</h4>
                  <p>{getTranslatedString('autopay.whatItemsOnYourMonthlyBill')}</p>
                  <label style={{ marginTop: '10px', fontSize: '14px' }}>
                    {getTranslatedString('autopay.enterAllocationDetails')}
                  </label>
                  <Field // TODO Be able to change border color on focus for date picker and text fields
                    name="apply_partial_monthly_amount_to"
                    component={TextField}
                    multiline
                    placeholder={getTranslatedString('autopay.enterAllocationDetailsPlaceholder')}
                    rows={4}
                    rowsMax={5}
                    variant="outlined"
                  />
                </div>
              </div>
            )}
          </div>
        )}
        {!isExternal && (
          <Explainations>
            <Title>{getTranslatedString('autopay.explaination.learnMoreAbout')}</Title>
            <Divider />
            <Link onClick={() => setShowHowItWorks(!showHowItWorks, 'optionA')}>
              {getTranslatedString('autopay.explaination.optionA')}
            </Link>
            <Link onClick={() => setShowHowItWorks(!showHowItWorks, 'other')}>
              {getTranslatedString('autopay.explaination.otherCharges')}
            </Link>
          </Explainations>
        )}
      </div>
    </div>
  );
};

export default AutoPayAmountDetails;